export default __webpack_public_path__ + "static/media/expressC.64f4d1c4.webp";